import { List, Map, Record } from 'immutable';

export default Record({
    cancel_at_period_end: false,
    canceled_at: null,
    current_period_end: null,
    current_period_start: null,
    days_until_due: null,
    discount: null,
    id: null,
    plan: Map({
        amount: null,
        created: null,
        currency: null,
        id: null,
        interval: null,
        interval_count: null,
        livemode: null,
        metadata: List([]),
        name: null,
        object: null,
        statement_description: null,
        statement_descriptor: null,
        trial_period_days: null,
    }),
    start: null,
    status: null,
});



// WEBPACK FOOTER //
// ./src/records/subscription.js